import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import DemandeVerificationService from "@/integrations/service/demande-verification.service";

const QUERY_KEY = ["demandes-verification"];

export const useCreerDemandeVerification = () => {
  return useMutation({
    mutationFn: DemandeVerificationService.creer,
  });
};

export const useUploadPieceJointeDemande = () => {
  return useMutation({
    mutationFn: DemandeVerificationService.uploadPieceJointe,
  });
};

export const useDemandesVerification = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: DemandeVerificationService.getAll,
  });
};

export const useMarquerLueDemandeVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: DemandeVerificationService.marquerLue,
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useDeleteDemandeVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: DemandeVerificationService.delete,
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
